/* Willamette & Fir — core: drawers, cart, UI */
(function () {
  'use strict';
  var WF = window.WF = window.WF || {};
  var $ = WF.$ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = WF.$$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var drawerEl = $('#wf-cart-drawer');
  var moneyFormat = (drawerEl && drawerEl.getAttribute('data-money-format')) || '${{amount}}';
  WF.money = function (cents) {
    cents = Number(cents) || 0;
    var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount';
    function d(n, p, t, s) { var v = (n / 100).toFixed(p).split('.'); v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return v.join(s); }
    var val = key === 'amount_no_decimals' ? d(cents, 0, ',', '.') : key === 'amount_with_comma_separator' ? d(cents, 2, '.', ',') : d(cents, 2, ',', '.');
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, val);
  };
  var money = WF.money;

  /* drawers & modals */
  var lastFocus = null;
  WF.open = function (el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var p = $('.wf-drawer__panel, .wf-modal__panel', el), f = p && $('button, a, input, select', p);
    if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 80);
  };
  WF.close = function (el) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!$('.wf-drawer.is-open, .wf-modal.is-open')) document.documentElement.style.overflow = '';
    if (lastFocus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  };
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-wf-open]');
    if (o) { e.preventDefault(); WF.open(document.getElementById(o.getAttribute('data-wf-open'))); return; }
    var c = e.target.closest('[data-wf-close]');
    if (c) { e.preventDefault(); WF.close(c.closest('.wf-drawer, .wf-modal')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeLightbox();
    $$('.wf-drawer.is-open, .wf-modal.is-open').forEach(WF.close);
  });

  /* announcement */
  $$('[data-wf-rotator]').forEach(function (r) {
    var items = $$('.wf-announce__item', r), i = 0; if (items.length < 2) return;
    setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 4200);
  });

  /* search */
  $$('[data-wf-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function () { var s = $('[data-wf-search]'); if (!s) return; s.classList.toggle('is-open'); if (s.classList.contains('is-open')) $('input', s).focus(); });
  });

  /* rails */
  $$('[data-wf-rail-nav]').forEach(function (nav) {
    var rail = document.getElementById(nav.getAttribute('data-wf-rail-nav')); if (!rail) return;
    $$('button', nav).forEach(function (b) {
      b.addEventListener('click', function () { rail.scrollBy({ left: (b.getAttribute('data-dir') === 'prev' ? -1 : 1) * rail.clientWidth * 0.8, behavior: 'smooth' }); });
    });
  });

  /* hero video cycle */
  $$('[data-wf-hero]').forEach(function (hero) {
    var vids = $$('video', hero), dots = $$('.wf-hero__dots button', hero), i = 0, timer;
    if (!vids.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      i = n;
      vids.forEach(function (v, k) { v.classList.toggle('is-active', k === n); if (k !== n) { try { v.pause(); } catch (e) {} } });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === n); });
      var v = vids[n];
      if (!reduce) { try { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
      clearTimeout(timer);
      timer = setTimeout(function () { show((i + 1) % vids.length); }, (v.duration && isFinite(v.duration) ? v.duration * 1000 - 400 : 5200));
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    if (vids.length > 1) vids.forEach(function (v) { v.addEventListener('ended', function () { if (v === vids[i]) show((i + 1) % vids.length); }); });
    else vids[0].loop = true;
    show(0);
  });

  /* FAQ tabs */
  $$('[data-wf-faq]').forEach(function (faq) {
    var tabs = $$('.wf-faq__tab', faq), panels = $$('.wf-faq__panel', faq);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.id !== t.getAttribute('aria-controls'); });
      });
    });
  });

  /* lightbox */
  var lb;
  function closeLightbox() { if (lb && lb.classList.contains('is-open')) { lb.classList.remove('is-open'); lb.innerHTML = ''; if (!$('.wf-drawer.is-open, .wf-modal.is-open')) document.documentElement.style.overflow = ''; } }
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-wf-zoom]'); if (!m) return;
    var src = m.getAttribute('data-wf-zoom'); if (!src) return;
    e.preventDefault();
    if (!lb) { lb = document.createElement('div'); lb.className = 'wf-lightbox'; document.body.appendChild(lb); lb.addEventListener('click', function (ev) { if (ev.target === lb || ev.target.closest('.wf-lightbox__close')) closeLightbox(); }); }
    var isVid = /\.mp4/.test(src);
    lb.innerHTML = '<button class="wf-iconbtn wf-lightbox__close" aria-label="Close" style="color:#fff;font-size:22px">&times;</button>' + (isVid ? '<video src="' + src + '" controls autoplay playsinline></video>' : '<img src="' + src + '" alt="">');
    lb.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
  });

  /* cart */
  var tiers = [];
  try { tiers = JSON.parse(drawerEl.getAttribute('data-tiers')); } catch (e) {}
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function renderTiers(count) {
    if (!drawerEl || !tiers.length) return;
    var msg = $('[data-wf-tier-msg]', drawerEl), fill = $('[data-wf-tier-fill]', drawerEl);
    var max = tiers[tiers.length - 1].qty, cur = null, next = null;
    tiers.forEach(function (t) { if (count >= t.qty) cur = t; else if (!next) next = t; });
    if (!cur) { var need = next.qty - count; msg.innerHTML = 'Add <b>' + need + ' more item' + (need > 1 ? 's' : '') + '</b> and save <b>' + next.pct + '%</b> on your order.'; }
    else if (next) msg.innerHTML = 'You\'re saving <b>' + cur.pct + '%</b>. Add <b>1 more item</b> to save <b>' + next.pct + '%</b>.';
    else msg.innerHTML = 'You\'ve unlocked our best price: <b>' + cur.pct + '% off</b> your order.';
    fill.style.width = Math.min(100, count / max * 100) + '%';
    $$('[data-step]', drawerEl).forEach(function (s) { s.classList.toggle('is-done', count >= Number(s.getAttribute('data-step'))); });
  }
  function renderCart(cart) {
    $$('[data-wf-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.setAttribute('data-count', cart.item_count); });
    if (!drawerEl) return;
    var hc = $('[data-wf-cart-heading-count]', drawerEl); if (hc) hc.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    var list = $('[data-wf-cart-items]', drawerEl), empty = $('[data-wf-cart-empty]', drawerEl), foot = $('[data-wf-cart-foot]', drawerEl), tierBox = $('[data-wf-tiers]', drawerEl);
    renderTiers(cart.item_count);
    if (!cart.item_count) { list.innerHTML = ''; empty.hidden = false; foot.hidden = true; if (tierBox) tierBox.hidden = true; return; }
    empty.hidden = true; foot.hidden = false; if (tierBox) tierBox.hidden = false;
    list.innerHTML = cart.items.map(function (it, idx) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.value); }).join(' / ');
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<li class="wf-line" data-line="' + (idx + 1) + '">' +
        '<a href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sized(it.image, 160)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><a class="wf-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (opts ? '<p class="wf-line__var">' + opts + '</p>' : '') +
        '<div style="display:flex;align-items:center"><div class="wf-qty"><button type="button" data-qty="-1" aria-label="Decrease">&minus;</button><input type="number" min="0" value="' + it.quantity + '" aria-label="Quantity" data-qty-input><button type="button" data-qty="1" aria-label="Increase">+</button></div>' +
        '<button type="button" class="wf-line__remove" data-remove>Remove</button></div></div>' +
        '<div class="wf-line__price">' + was + money(it.final_line_price) + '</div></li>';
    }).join('');
    $('[data-wf-cart-original]', drawerEl).textContent = money(cart.original_total_price);
    $('[data-wf-cart-total]', drawerEl).textContent = money(cart.total_price);
    var saveRow = $('[data-wf-cart-save-row]', drawerEl);
    if (cart.total_discount > 0) {
      saveRow.hidden = false;
      $('[data-wf-cart-save]', drawerEl).textContent = '−' + money(cart.total_discount);
      var app = cart.cart_level_discount_applications && cart.cart_level_discount_applications[0];
      $('[data-wf-cart-save-label]', drawerEl).textContent = app ? app.title : 'Savings';
    } else saveRow.hidden = true;
  }
  WF.fetchCart = function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; }); };
  function changeLine(line, qty) {
    drawerEl.classList.add('is-loading');
    return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {}).then(function () { drawerEl.classList.remove('is-loading'); });
  }
  WF.addToCart = function (items) {
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); })
      .then(WF.fetchCart).then(function () { WF.open(drawerEl); });
  };
  if (drawerEl) {
    document.addEventListener('click', function (e) { if (e.target.closest('[data-wf-cart-open]')) { e.preventDefault(); WF.fetchCart(); WF.open(drawerEl); } });
    drawerEl.addEventListener('click', function (e) {
      var li = e.target.closest('.wf-line'); if (!li) return;
      var line = Number(li.getAttribute('data-line')), q = e.target.closest('[data-qty]'), input = $('[data-qty-input]', li);
      if (q) changeLine(line, Math.max(0, Number(input.value) + Number(q.getAttribute('data-qty'))));
      if (e.target.closest('[data-remove]')) changeLine(line, 0);
    });
    drawerEl.addEventListener('change', function (e) {
      if (e.target.matches('[data-qty-input]')) changeLine(Number(e.target.closest('.wf-line').getAttribute('data-line')), Math.max(0, Number(e.target.value) || 0));
    });
    WF.fetchCart().catch(function () {});
  }

  /* recommendations */
  $$('[data-wf-recs]').forEach(function (box) {
    fetch(box.getAttribute('data-wf-recs')).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html; var inner = $('[data-wf-recs-inner]', tmp);
      if (inner && inner.children.length) { box.innerHTML = inner.innerHTML; var s = box.closest('section'); if (s) s.hidden = false; }
    }).catch(function () {});
  });
})();